import { render, staticRenderFns } from "./Feeds.vue?vue&type=template&id=2dd8ade0&scoped=true"
import script from "./Feeds.vue?vue&type=script&lang=js"
export * from "./Feeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8ade0",
  null
  
)

export default component.exports